  var _cio = _cio || [];

  (function() {
    var a, b, c;
    a = function(f) {
      return function() { _cio.push([f].concat(Array.prototype.slice.call(arguments, 0))); };
    };
    b = ["load", "identify", "sidentify", "track", "page", "on"];
    for (c = 0; c < b.length; c++) { _cio[b[c]] = a(b[c]); }

    var t = document.createElement('script');
    t.async = true;
    t.id = 'cio-tracker';
    t.setAttribute('data-site-id', '112662afd28ca282fdec');
    t.setAttribute('data-use-array-params', 'true');

    // 1. Włączenie wiadomości In-App
    t.setAttribute('data-use-in-app', 'true');

    // 2. Wsparcie dla wiadomości In-App do profilów anonimowych (przed identify)
    t.setAttribute('data-use-anonymous-in-app', 'true');

    // 3. Konfiguracja Color Scheme (auto / light / dark)
    // "auto" dostosowuje wygląd do preferencji systemowych użytkownika (prefers-color-scheme)
    t.setAttribute('data-in-app-config', JSON.stringify({
      colorScheme: 'auto'
    }));

    t.src = 'https://assets.customer.io/assets/track.js';
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(t, s);
  })();

  // 4. Nasłuchiwanie zdarzeń wiadomości In-App (Events Listener)
  _cio.on("in-app", function(event) {
    console.log("In-App Event:", event.type, event);

    switch(event.type) {
      case "opened":
        // Wywołuje się po wyświetleniu wiadomości użytkownikowi
        break;
      case "action":
        // Wywołuje się po kliknięciu przycisku / linku w wiadomości
        // Przykładowy dostęp do akcji: event.data.actionName lub event.data.value
        break;
      case "dismissed":
        // Wywołuje się po zamknięciu wiadomości (np. kliknięcie 'X' lub tła)
        break;
      case "error":
        // Wywołuje się w przypadku błędu renderowania
        break;
    }
  });